import { NavLink, useLocation } from 'react-router-dom';
import "./Menu.css";
import Logo from '../../components/logo/LogoMenu';


export default function Menu({ onClick, isClicked, isMode }) {

    const location = useLocation();
    // Funzione per determinare se un NavLink è attivo
    const isActive = (path) => location.pathname === path;

    return (
        <aside className={`${isClicked ? "" : "show-menu-sx"} layout-menu-fixed layout-menu menu-vertical menu bg-menu-theme`} >
            {/* Logo */}
            <Logo onClick={onClick} isClicked={isClicked} isMode={isMode} />
             <ul className="menu-inner py-1 ps ps--active-y">
                <li className={isActive("/home") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/home" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-home-smile"></i>
                        <div className="text-truncate">Home</div>
                    </NavLink>
                </li>
                <li className={isActive("/client") ? "menu-item active" : "menu-item"}>
                    <NavLink to="/client" className="menu-link">
                        <i className="menu-icon tf-icons bx bxs-contact"></i>
                        <div className="text-truncate">Clienti</div>
                    </NavLink>
                </li>
             </ul>
        </aside>
  );
}